import EditorAddIcon from '@atlaskit/icon/glyph/editor/add';
import { Flex, Text, xcss } from '@atlaskit/primitives';
import { ViewComponentProps } from '@databases/fields/view/types';
import { messages } from '@databases/intl/messages';
import { DatabaseAttachment, DatabaseFieldType } from '@databases/types/database';
import { ValueChange } from '@databases/utils/database/changesets';
import React, { FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';

import { AttachmentViewer } from '../../AttachmentViewer';

interface AttachmentValueType extends ViewComponentProps<DatabaseFieldType.ATTACHMENT> {
  handleChange?: (
    value:
      | DatabaseAttachment
      | File
      | {
          src: string;
        }
      | {
          fileId: string;
        }
      | undefined,
    change: ValueChange | null
  ) => void;
  onReplace?: () => void;
}

const AttachmentValueView: FunctionComponent<AttachmentValueType> = ({
  contentId,
  value,
  showPlaceholder,
  handleChange,
  onReplace,
}) => {
  const { formatMessage } = useIntl();

  if (!value) {
    return (
      showPlaceholder && (
        <Flex
          xcss={xcss({
            justifyContent: 'space-between',
            alignItems: 'center',
            color: 'color.text.subtle',
            opacity: 0,
            width: '152px',
          })}
        >
          <EditorAddIcon label="" />
          <Text color={'color.text.subtle'}>
            {formatMessage(messages['media.add-or-drop-file'])}
          </Text>
        </Flex>
      )
    );
  }

  return (
    <AttachmentViewer
      contentId={contentId}
      value={value}
      onReplace={onReplace}
      handleChange={handleChange}
    />
  );
};

export default AttachmentValueView;
